import { fromJS } from 'immutable';
import { createAsyncAction } from '../utils';

const initialState = fromJS({ loading: false, error: null, list: [] });

export const getEnvironmentTypes = createAsyncAction('GET_ENVIRONMENT_TYPES');

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case getEnvironmentTypes.REQUEST:
            return state
                .update('loading', () => true)
                .update('error', () => null);
        case getEnvironmentTypes.SUCCESS:
            return state
                .update('loading', () => false)
                .update('list', () => fromJS(action.payload));
        case getEnvironmentTypes.FAIL:
            return state
                .update('loading', () => false)
                .update('error', () => action.payload);
        default:
            return state;
    }
}

export function environmentTypesActions($http, api) {
    'ngInject';

    function loadEnvironmentTypes({ projectIds, groupIds }) {
        return dispatch => {
            const options = (projectIds || groupIds) ? { projectIds, groupIds } : undefined;
            dispatch({ type: getEnvironmentTypes.REQUEST });
            return $http.post(`${api.restServiceUrlDB}environmenttypes`,options).then(response => {
                const data = response.data.map(x => ({ id: x.envTypeId, name: x.envTypeName }));
                dispatch({ type: getEnvironmentTypes.SUCCESS, payload: data });
            }, error => {
                dispatch({ type: getEnvironmentTypes.FAIL, error: true, payload: error.data });
            });
        }
    }

    return { loadEnvironmentTypes };
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/redux/environment-types.js